<ng-container *ngIf="data$ | async as data">
    <cx-generic-link
        [class.mini-cart-disabled]="data.disabled"
        [url]="data.url"
        [target]="data.target" 
        [title]="data.title">
        <img
            class="cart-icon"
            src="../../../../../assets/icons/shopping_cart_white.svg" 
            alt="Shopping Cart">
        
        <span class="cart-badge">{{ data.items }}</span>
    </cx-generic-link>
</ng-container>
